import { FunctionComponent, useEffect, useState, useRef } from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
  Typography,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  TablePagination,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router-dom";
import AbonelerAPI from "../../../apis/OB/Get/AbonelerAPI";
import AboneSicilListeAPI from "../../../apis/OB/Get/AboneSicilListeAPI";
import TahsisIptalNedenListe from "../../../apis/OB/Get/TahsisIptalNedenListe";
import AbonelikIptalBasvuruAPI from "../../../apis/OB/SaveApi/AbonelikIptal";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import Recaptcha from "../../../components/Recaptcha";
import { toast } from "react-toastify";

const AbonelikIptalSozlesmeIptal: FunctionComponent = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [aboneData, setAboneData] = useState<any[]>([]);
  const [aciklamaIcerik, setAciklamaIcerik] = useState<string>(
    "Abonelik seçtiğinizde burada açıklama gözükür."
  );
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [aboneNo, setAboneNo] = useState<number | undefined>(undefined);
  const [checkedIndex, setCheckedIndex] = useState<number | null>(null);
  const [islemTuruList, setIslemTuruList] = useState<any[]>([]);
  const [popupContent, setPopupContent] = useState<string>("");
  let user = SessionStorageService.getUserInfo();
  const navigate = useNavigate();
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [userControlPopup, setUserControlPopup] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(4);
  const [aktifAboneVarMi, setAktifAboneVarMi] = useState<boolean>(false);

  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  };

  useEffect(() => {
    if (user == null) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, [user]);

  const closePopup = () => {
    setIsPopupVisible(false);
    if (aktifAboneVarMi === false) {
      navigate(-1)
    }
  };

  const openPopup = (content: string) => {
    setPopupContent(content);
    setIsPopupVisible(true);
  };

  useEffect(() => {
    if (user) {
      TahsisIptalNedenListe.getTahsisIptalNedenListe(undefined)
        .then((res) => {
          setIslemTuruList(res.data);
        })
        .catch((err) => {
          console.error("Tahsis İptal Neden Liste API hatası:", err);
        });
    }
  }, []);

  const fetchData = () => {
    if (aboneNo !== undefined && !isNaN(aboneNo) && user) {
      setIsLoading(true);
      AboneSicilListeAPI.getAboneSicilListe(
        user?.sicilKodu,
        aboneNo === -1 ? undefined : aboneNo
      )
        .then((res) => {
          if (res.data.length > 0) {
            setData(res.data);
          } else {
            openPopup("Veri bulunamadı!");
          }
        })
        .catch((err) => {
          console.error("Abone Sicil Liste API hatası:", err);
          openPopup("API hatası: " + err.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (user) {
      AboneSicilListeAPI.getAboneSicilListe(
        user?.sicilKodu,
        aboneNo === -1 ? undefined : aboneNo
      )
        .then((res) => {
          if (res.data.length > 0) {
            setData(res.data);
          } else {
            openPopup("Veri bulunamadı!");
          }
        })
        .catch((err) => {
          console.error("Abone Sicil Liste API hatası:", err);
          openPopup("API hatası: " + err.message);
        });
    }
  }, []);

  useEffect(() => {
    if (user) {
      AbonelerAPI.getAbonelerListe(2,user?.sicilKodu)
        .then((res) => {
          if (res.data.length > 0) {
            setAktifAboneVarMi(true)
            setAboneData(res.data)
          } else {
            openPopup("Aktif bir aboneliğiniz bulunmadığı için bu sayfa da işlem yapamazsınız.");
          }
        })
        .catch((err) => {
          console.error("Aboneler Liste API hatası:", err);
          openPopup("API hatası: " + err.message);
        });
    }
  }, []);

  const clearAllInputs = () => {
    formik.resetForm();
    setCheckedIndex(null);
    fetchData();
    setAciklamaIcerik("Abonelik seçtiğinizde burada açıklama gözükür.");
  };

  const formik = useFormik({
    initialValues: {
      sonEndeks: "",
      iban: "TR",
      islemTuru: -1,
    },
    validationSchema: Yup.object({
      sonEndeks: Yup.number()
        .required('Son endeks giriniz')
        .min(0, 'Son endeks negatif olamaz'),
      iban: Yup.string()
        .matches(/^TR/, "IBAN numarası TR ile başlamalıdır")
        .length(26, "IBAN numarası 26 haneli olmalıdır")
        .required("IBAN numarası giriniz"),
      islemTuru: Yup.number().min(0, "İşlem türü seçiniz").required("İşlem türü seçiniz"),
    }),
    onSubmit: async (values) => {
      if (checkedIndex === null) {
        openPopup("Lütfen bir abone seçiniz.");
        return;
      }
      // reCAPTCHA’yı tetikle
      const token = await recaptchaRef.current?.handleSubmit();
      if (!token) {
        toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
        return;
      }
      const request = {
        sicilKodu: user?.sicilKodu,
        basvuruTuruId: 302,
        aboneNo: checkedIndex,
        islemTuruKodu: values.islemTuru,
        sonEndeks: Number(values.sonEndeks),
        ibanNumarasi: values.iban,
        captchaToken: token
      };
      AbonelikIptalBasvuruAPI.saveAbonelikIptalBasvuruSave(request)
        .then((res) => {
          if (res.data.sonuc === 0) {
            let basvuruNo = res.data.basvuruNo;
            setPopupContent(
              "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
              basvuruNo
            );
            setIsPopupVisible(true);
          } else {
            openPopup(res.data.sonucAciklama);
          }
        })
        .catch((err) => {
          openPopup(
            "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
          );
        })
        .finally(() => {
          recaptchaRef.current?.reset();
        });
    },
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return isLoad ? <>
    <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
    {userControlPopup ? (

      <AciklamaAndUserControlPopup
        open={userControlPopup}
        handleClose={closeUserControlPopup}
        isUserControlPopUp={true}
        description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
      />

    ) : null}
  </> : (
    <>
      <Card className="w-100">
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2}>
                <TextField
                  size="small"
                  select
                  fullWidth
                  label="Abone No"
                  value={aboneNo ?? ""}
                  onChange={(e) => setAboneNo(Number(e.target.value))}
                >
                  <MenuItem value={-1}>Abone No</MenuItem>
                  {aboneData.map((item, index) => (
                    <MenuItem key={index} value={item.aboneNo}>
                      {item.aboneNo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={10}
                container
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item>
                  <Button variant="contained" onClick={fetchData}>
                    Ara
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={clearAllInputs}>
                    Temizle
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <Typography>Loading...</Typography>
                ) : (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Abone No</TableCell>
                          <TableCell>Abone Tipi</TableCell>
                          <TableCell>Sayaç Markası</TableCell>
                          <TableCell>Sayaç No</TableCell>
                          <TableCell>Adres</TableCell>
                          <TableCell>Teminat Tutarı</TableCell>
                          <TableCell>Borç Tutarı</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data
                          .slice(
                            currentPage * rowsPerPage,
                            currentPage * rowsPerPage + rowsPerPage
                          )
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Checkbox
                                  checked={checkedIndex === Number(item.aboneNo)}
                                  onChange={() => {
                                    if (checkedIndex === Number(item.aboneNo)) {
                                      setCheckedIndex(null);
                                      setAciklamaIcerik(
                                        "Abonelik seçtiğinizde burada açıklama gözükür."
                                      );
                                    } else {
                                      setCheckedIndex(Number(item.aboneNo));
                                      if (item.borcTutari > item.teminatTutari) {
                                        setAciklamaIcerik(
                                          "Borcunuz teminat tutarınızdan fazladır. Teminat tutarınız borcunuzdan mahsup yapılacak ve sms ile bilgilendirme alacaksınız. SMS bilgilendirmesinden sonra kalan borcunuzu ödeyebilirsiniz."
                                        );
                                      } else {
                                        setAciklamaIcerik(
                                          "Borcunuz teminatınızdan mahsup edilecek ve kalan teminat tutarı IBAN numaranıza yatırılacaktır."
                                        );
                                      }
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell>{item.aboneNo}</TableCell>
                              <TableCell>{item.aboneTipi}</TableCell>
                              <TableCell>{item.sayacMarkası}</TableCell>
                              <TableCell>{item.sayacNo}</TableCell>
                              <TableCell>{item.adres}</TableCell>
                              <TableCell>{item.teminatTutari}</TableCell>
                              <TableCell>{item.borcTutari}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[4, 10, 25]}
                      component="div"
                      count={data.length}
                      rowsPerPage={rowsPerPage}
                      page={currentPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  select
                  fullWidth
                  label="İşlem Türü"
                  value={formik.values.islemTuru}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="islemTuru"
                  error={formik.touched.islemTuru && Boolean(formik.errors.islemTuru)}
                  helperText={formik.touched.islemTuru && formik.errors.islemTuru}
                >
                  <MenuItem value={-1}>Seçiniz</MenuItem>
                  {islemTuruList.map((item, index) => (
                    <MenuItem key={index} value={item.tahsisIptalNedenKodu}>
                      {item.tahsisIptalNedenAdi}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="Son Endeks"
                  type="number"
                  value={formik.values.sonEndeks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="sonEndeks"
                  error={formik.touched.sonEndeks && Boolean(formik.errors.sonEndeks)}
                  helperText={formik.touched.sonEndeks && formik.errors.sonEndeks}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Ödeme Bilgileri
                </Typography>
                <Typography>{aciklamaIcerik}</Typography>
                <TextField
                  className="mt-2"
                  size="small"
                  fullWidth
                  label="IBAN"
                  value={formik.values.iban}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="iban"
                  inputProps={{ maxLength: 26 }}
                  error={formik.touched.iban && Boolean(formik.errors.iban)}
                  helperText={formik.touched.iban && formik.errors.iban}
                />
              </Grid>
              <Grid className="d-flex justify-content-end" item xs={12}>
                <Recaptcha
                  ref={recaptchaRef}
                  changeHandleRecaptcha={setRecaptchaPassed}
                />
                <Button variant="contained" type="submit">
                  Gönder
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      {isPopupVisible && (
        <BilgilendirmePopup
          basvuruTuruId={-5}
          isSorunBildirPopup={false}
          closePopup={closePopup}
          open={isPopupVisible}
          editDescription={popupContent}
        />
      )}</>
  );
};

export default AbonelikIptalSozlesmeIptal;
